module.exports = __webpack_public_path__ + "img/crystal-rubber.0ae78e5d.png";